/* Tema editorial — Carlos Pérez García
   1) header con sombra al hacer scroll  2) menú móvil  3) haz de faro ligado al scroll
   4) aparición suave de bloques. Respeta prefers-reduced-motion. */
(function () {
  document.documentElement.classList.remove('no-js');

  /* 1) header */
  var hdr = document.getElementById('hdr');
  function onScroll() { if (hdr) document.body.classList.toggle('scrolled', window.scrollY > 30); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* 2) menú móvil */
  var burger = document.getElementById('burger'), nav = document.getElementById('nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* 3) haz de faro: gira con el scroll (solo en la portada) */
  var pivot = document.getElementById('beamPivot');
  var hero = document.querySelector('[data-hero]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (pivot && hero && !reduce) {
    var START = 5.5;   // apunta al titular: el texto queda dentro del haz al cargar
    var SWEEP = 200;   // al hacer scroll barre en sentido horario hacia la derecha
    var cur = START, running = false, on = false;
    var target = function () {
      var h = hero.offsetHeight || window.innerHeight;
      var p = Math.max(0, Math.min(1, (window.scrollY || 0) / h));
      return START + p * SWEEP;
    };
    var tick = function () {
      if (!on) { running = false; return; }
      var t = target(), diff = t - cur;
      if (Math.abs(diff) > 0.05) { cur += diff * 0.16; running = true; requestAnimationFrame(tick); }
      else { cur = t; running = false; }
      pivot.style.transform = 'rotate(' + cur.toFixed(2) + 'deg)';
    };
    var ensure = function () { if (on && !running) { running = true; requestAnimationFrame(tick); } };
    window.addEventListener('scroll', ensure, { passive: true });
    window.addEventListener('resize', ensure, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { on = e.isIntersecting; ensure(); });
      }, { threshold: 0 }).observe(hero);
    } else { on = true; ensure(); }
    pivot.style.transform = 'rotate(' + cur.toFixed(2) + 'deg)';
  }

  /* 3c) el titular SIEMPRE dentro del haz de luz, en cualquier resolucion.
     El haz es un triangulo con vertice en la linterna, eje a 5.5 grados y
     semiespesor (300/anchoHaz)*distancia. El punto critico del bloque es su
     borde IZQUIERDO (donde el haz es mas estrecho), asi que se centra el
     bloque en el eje medido a esa distancia; si el bloque es mas alto que el
     hueco disponible, se limita el tamano del titular para que quepa. */
  var faroLuz = document.querySelector('.hero .faro');
  var bloqueTit = document.querySelector('.hero-copy .hgroup');
  var copiaHero = document.querySelector('.hero-copy');
  var arranque = hero && hero.getAttribute('data-beam-start') ? parseFloat(hero.getAttribute('data-beam-start')) : 5.5;
  if (hero && faroLuz && bloqueTit && copiaHero) {
    var colocaTitular = function () {
      var raiz = document.documentElement;
      if (window.innerWidth < 1021) {
        raiz.style.removeProperty('--hero-copy-top');
        raiz.style.removeProperty('--hero-h1-max');
        raiz.style.removeProperty('--hero-copy-left');
        return;
      }
      if (window.scrollY > 60) return;               /* solo en la parte alta de la portada */
      var fr = faroLuz.getBoundingClientRect(), hr = hero.getBoundingClientRect();
      if (fr.height < 10 || hr.height < 10) return;
      var lampX = fr.left + fr.width * 0.5;
      var lampY = fr.top + fr.height * 0.1806;       /* la linterna dentro del faro */
      var anchoHaz = Math.min(2000, window.innerWidth * 1.5);   /* largo del haz */
      var pendiente = 300 / anchoHaz;                /* borde del haz */
      var eje = Math.tan((reduce ? 0 : arranque) * Math.PI / 180);
      var cr, alto, ancho, dx, semialto;
      /* 1) el bloque entero tiene que caber en el LARGO del haz: si se pasa,
            se acerca la columna hacia la linterna (--hero-copy-left).
            Se parte siempre de la posicion natural (sin la variable) para que
            el calculo sea idempotente al redimensionar. */
      raiz.style.removeProperty('--hero-copy-left');
      cr = copiaHero.getBoundingClientRect();
      ancho = bloqueTit.getBoundingClientRect().width;
      var maxIzq = lampX + anchoHaz - ancho - 40;
      if (cr.left > maxIzq + 1) { raiz.style.setProperty('--hero-copy-left', Math.round(maxIzq) + 'px'); }
      cr = copiaHero.getBoundingClientRect();
      dx = Math.max(140, cr.left - lampX);
      semialto = pendiente * dx;                     /* hueco del haz en ese punto */
      alto = bloqueTit.getBoundingClientRect().height;
      /* 2) si no cabe de alto en el haz, se reduce el titular (minimo legible) */
      if (alto > 2 * semialto - 36) {
        var fs = parseFloat(getComputedStyle(bloqueTit.querySelector('h1') || bloqueTit).fontSize) || 54;
        var tope = Math.max(30, Math.floor(fs * (2 * semialto - 36) / alto));
        raiz.style.setProperty('--hero-h1-max', tope + 'px');
        alto = bloqueTit.getBoundingClientRect().height;
      }
      /* 3) centrado en el eje del haz medido en el borde izquierdo del bloque */
      var centro = lampY + eje * dx;
      var top = centro - hr.top - alto / 2;
      var cabecera = document.querySelector('header');
      var minTop = (cabecera ? cabecera.getBoundingClientRect().height : 90) + 16;
      var grupo = document.querySelector('.hero-copy .cluster');
      var maxTop = minTop + 1;
      if (grupo) maxTop = (grupo.getBoundingClientRect().top - hr.top) - alto - 24;
      if (maxTop > minTop) top = Math.min(Math.max(top, minTop), maxTop);
      raiz.style.setProperty('--hero-copy-top', Math.round(top) + 'px');
    };
    colocaTitular();
    window.addEventListener('resize', colocaTitular, { passive: true });
    window.addEventListener('load', colocaTitular);
    window.addEventListener('scroll', function () { if (window.scrollY < 20) colocaTitular(); }, { passive: true });
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(colocaTitular); }
    setTimeout(colocaTitular, 500);
  }

  /* 4b) altura real de la cabecera -> variable CSS --hdr-h
     La cabecera es fija y su alto cambia (nombre del autor a una o dos lineas).
     Los bloques de arriba de cada pagina usan esa medida para no quedar debajo. */
  var hdrEl = document.querySelector('header');
  function mideHeader() {
    if (!hdrEl) return;
    var h = Math.round(hdrEl.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--hdr-h', h + 'px');
  }
  mideHeader();
  window.addEventListener('resize', mideHeader, { passive: true });
  window.addEventListener('load', mideHeader);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(mideHeader); }
  setTimeout(mideHeader, 500);

  /* 4) aparición suave */
  var rvs = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window && rvs.length && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    rvs.forEach(function (el) { io.observe(el); });
  } else {
    rvs.forEach(function (el) { el.classList.add('in'); });
  }
})();
